import { render, staticRenderFns } from "./FreightRatesGrid.vue?vue&type=template&id=7515b034"
import script from "./FreightRatesGrid.vue?vue&type=script&lang=js"
export * from "./FreightRatesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports